import { Radio, RadioGroup } from 'components/RadioGroup'
import Styles from './CaptionOptionsList.module.scss'
import React from 'react'

interface CaptionOptionsListProps {
  options: string[]
  selectedIndex: number
  onSelect: (index: number) => void
  disabled?: boolean
}

export const CaptionOptionsList: React.FC<CaptionOptionsListProps> = ({
  options,
  selectedIndex,
  onSelect,
  disabled,
}) => {
  const handleChange = (value: string) => {
    const index = parseInt(value, 10)
    onSelect(index)
  }

  const renderOption = (option: string, index: number) => (
    <label key={index} className={Styles.optionContainer}>
      <Radio value={String(index)} isDisabled={disabled}>
        <span />
      </Radio>
      <div className={Styles.contentWrapper}>
        <div>
          <div className={Styles.optionLabelOutside}>Option {index + 1}</div>
          <div className={Styles.optionContent}>
            <div className={Styles.optionText}>{option}</div>
          </div>
        </div>
      </div>
    </label>
  )

  return (
    <RadioGroup value={String(selectedIndex)} onChange={handleChange}>
      {options.map(renderOption)}
    </RadioGroup>
  )
}
